<!-- Method, only when the Driver is Patient -->
<div class="forecast-table-grid-select-container">
  <ng-select
    #dropdown
    class="forecast-table-grid-select"
    [searchable]="false"
    [clearable]="false"
    [appendTo]="'ag-grid-angular'"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [auxTooltip]="tooltip"
    [ngClass]="{ 'is-invalid': isInvalid }"
    [(ngModel)]="selectedPatientCurve"
    (open)="onDropdownOpen()"
    (close)="onDropdownClose()"
  >
    @for (item of patientCurves; track item; let index = $index; let first = $first) {
      <ng-option [value]="item.value">
        {{ item.name }}
      </ng-option>
    }
    <ng-template ng-footer-tmp class="flex flex-col">
      <div class="items-wrapper grow">
        @for (item of patientCurves; track item; let first = $first; let last = $last) {
          <ng-option [value]="item.value">
            @if (item.showLine && !first) {
              <div class="mx-1 my-1 h-1 border-b border-aux-gray-darkest"></div>
            }
            <div
              class="option-font relative -mx-2 flex cursor-pointer select-none justify-between py-3 pl-3"
              [class.selected-item]="selectedPatientCurve === item.value"
              [class.first-item]="first"
              [class.last-item]="last"
              [class.hover-item]="selectedPatientCurve !== item.value"
              (click)="select(item.value); dropdown.close()"
            >
              <div class="flex-1">
                {{ item.name }}
              </div>
              @if (dropdownOpen && selectedPatientCurve === item.value) {
                <aux-icon name="Check" class="checkmark mr-2" />
              }
            </div>
          </ng-option>
        }
      </div>
    </ng-template>
  </ng-select>
</div>
